import dynamic from "next/dynamic";

export const ContentListSideImage = dynamic(() => import("./component"));
